/**
 * pickInitialPlanDate — pure helper for ScheduleGoalsScreen's `date`
 * useState lazy initializer.
 *
 * Returns the YYYY-MM-DD string the Plan screen should mount with:
 *
 *   1. If the chatReveal store has an active plan-surface reveal with a
 *      concrete date, use that. This is how Reflect "View in Plan →"
 *      lands on the day the new ScheduleBlock actually lives (CLCD
 *      ship-blocker P0-1 fix, dogfood 2026-05-28).
 *   2. Otherwise, fall back to today's local date.
 *
 * Why this is a pure function instead of inline useState body:
 *   - Testable without mounting React + the entire ScheduleGoalsScreen.
 *   - PlanScreen remounts on every tab visit (key bump in page.tsx), so
 *     setDate-from-useEffect approaches lose the race against the
 *     remount's fresh useState. Reading the store synchronously at
 *     useState init is the only path that holds.
 *   - Strict Mode double-invoke of effects also undermines a
 *     useEffect-based "switch date on reveal" approach for the same
 *     reason; useState init runs once per mount, even under Strict Mode.
 */

import type { ActionReveal } from "@/lib/api";

export function pickInitialPlanDate(
  active: ActionReveal | null,
  todayLocalDateString: string,
): string {
  if (active && active.surface === "plan" && active.date) {
    return active.date;
  }
  return todayLocalDateString;
}
